module.exports = __webpack_public_path__ + "static/media/sch.ef8c0752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sch.png
// module id = 765
// module chunks = 0